import type { IClientUser } from '../interfaces/user';
import React from 'react';
import OnboardingForm from '../components/User/Forms/OnboardingForm/OnboardingForm';
import { CurrentUserContextProvider } from '../contexts/currentUserContext';
import logo from '../assets/svg/onboarding/logo.svg';

const OnboardingPage: React.FC<IClientUser> = () => {
  return (
      <main className="page-onboarding">
        <nav className="navbar onboarding-navbar">
          <div className="container">
            <div className="navbar-brand">
              <a href="/" className="navbar-item logo-link">
                <img src={logo} alt="Match Hat" className="logo" />
              </a>
            </div>
          </div>
        </nav>
        <section className="container m-t-0">
          <div className="columns section">
            {/* About You Badge desktop */}
            <div
              className="column is-three-quarters-tablet is-full-mobile"
              style={{ maxWidth: '750px' }}
            >
            {/* About You Badge tablet */}
              <CurrentUserContextProvider>
                <OnboardingForm />
              </CurrentUserContextProvider>
            </div>
          </div>
        </section>
      </main>
  );
};

export default OnboardingPage;
